function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import UseCaseDetailComponent from '@/apps/attributes/modules/use_cases/components/UseCaseDetailComponent';
import AddBaseIdsComponent from '@/apps/attributes/modules/use_cases/components/AddBaseIdsComponent';
import EditUsersComponent from '@/apps/attributes/modules/use_cases/components/EditUsersComponent';
import AddSandboxBase from '@/apps/attributes/modules/use_cases/components/AddSandboxBase';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState, mapMutations } from 'vuex';
import tasks from '@/js/tasks';
import EditAttributesComponent from '@/apps/attributes/modules/use_cases/components/EditAttributesComponent';
import RegisterFilterComponent from '@/apps/attributes/modules/use_cases/components/RegisterFilterComponent';
import CalendarComponent from '@/components/CalendarComponent';
import AddAttributeGroupComponent from '@/apps/attributes/components/AddAttributeGroupComponent';
import firebase from 'firebase';
export default {
  name: 'OwnershipHistoryPage',
  components: {
    CalendarComponent: CalendarComponent,
    AddSandboxBase: AddSandboxBase,
    EditAttributesComponent: EditAttributesComponent,
    DialogsComponent: DialogsComponent,
    UseCaseDetailComponent: UseCaseDetailComponent,
    AddBaseIdsComponent: AddBaseIdsComponent,
    EditUsersComponent: EditUsersComponent,
    RegisterFilterComponent: RegisterFilterComponent,
    AddAttributeGroupComponent: AddAttributeGroupComponent
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    var _this = this;
    var STATUS_ACTIVE = '1';
    var STATUS_INACTIVE = '0';
    return {
      STATUS_ACTIVE: STATUS_ACTIVE,
      STATUS_INACTIVE: STATUS_INACTIVE,
      DIALOG_CREATE_ATTR_GROUP: 'DIALOG_CREATE_ATTR_GROUP',
      DIALOG_EXTEND_VALIDITY: 'DIALOG_EXTEND_VALIDITY',
      DIALOG_SEE_REPORT_DETAIL: 'DIALOG_SEE_REPORT_DETAIL',
      DIALOG_ADD_INCA_BASE: 'DIALOG_ADD_INCA_BASE',
      DIALOG_REGISTER_FILTER: 'DIALOG_REGISTER_FILTER',
      DIALOG_ADD_USERS: 'DIALOG_ADD_USERS',
      DIALOG_EDIT_USERS: 'DIALOG_EDIT_USERS',
      DIALOG_EDIT_ATTRIBUTES: 'DIALOG_EDIT_ATTRIBUTES',
      DIALOG_EXPORT_AWS: 'DIALOG_EXPORT_AWS',
      DIALOG_DELETE: 'DIALOG_DELETE',
      DIALOG_EDIT_REQUEST: 'DIALOG_EDIT_REQUEST',
      DIALOG_ADD_SANDBOX_BASES: 'DIALOG_ADD_SANDBOX_BASES',
      DIALOG_DESENCRIPTAR_IDSANDBOX: 'DIALOG_DESENCRIPTAR_IDSANDBOX',
      today: new Date().toISOString().slice(0, 10),
      extendedValidityMonths: null,
      isLoading: false,
      has_partyid_match: false,
      search: '',
      filters: {
        text_filter: ''
      },
      table_items: [],
      views_and_columns: [],
      aws_schemes: [],
      selected_aws_scheme: null,
      items: [],
      itemToDelete: null,
      rules: {
        label: function label(value) {
          return !!value || 'Este campo es requerido.';
        },
        destination_scheme: [function (v) {
          return !!v || _this.translate('reglas.field');
        }]
      },
      items_key: 0,
      validityOptions: [{
        text: "1 mes",
        value: 1
      }, {
        text: "3 meses",
        value: 3
      }, {
        text: "6 meses",
        value: 6
      }],
      internalAttributes: [],
      useCaseId: null,
      lastVersionId: null,
      addBaseStatuses: {}
    };
  },
  created: function created() {
    this.checkCompanyCodeAndInit();
    this.listenToRealtimeStatuses();
  },
  methods: _objectSpread(_objectSpread({
    listenToRealtimeStatuses: function listenToRealtimeStatuses() {
      var _this2 = this;
      console.log('Listening to realtime statuses...');
      var db = firebase.firestore();
      var colRef = db.collection('add_base_statuses');
      colRef.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          var id = change.doc.id;
          var data = change.doc.data();
          var newStatus = data.last_status;
          var flagAlert = data.flag_attribute_alert;
          var response = data.response;
          var attributeCount = data.attribute_count;
          _this2.$set(_this2.addBaseStatuses, id, newStatus);

          // Buscas el ítem en tu tabla y actualizas el status_id si existe
          var index = _this2.items.findIndex(function (item) {
            return item.id.toString() === id;
          });
          if (index !== -1) {
            _this2.$set(_this2.items[index], 'status_id', parseInt(newStatus));
            _this2.$set(_this2.items[index], 'flag_attribute_alert', flagAlert);
            _this2.$set(_this2.items[index], 'response', response);
            if (attributeCount) _this2.$set(_this2.items[index], 'attribute_count', attributeCount);
          }
        });
      });
    },
    closeDialogFromChildren: function closeDialogFromChildren() {
      var _this3 = this;
      this.$nextTick(function () {
        console.log('Base eliminada');
        tasks.toast.success("Se esta eliminando la base");
        if (_this3.$refs[_this3.DIALOG_SEE_REPORT_DETAIL]) {
          _this3.init();
          _this3.$refs[_this3.DIALOG_SEE_REPORT_DETAIL].onClose();
        }
      });
    },
    onOpenDialogCreateAttrGroup: function onOpenDialogCreateAttrGroup(item, modalName) {
      this.internalAttributes = [];
      this.useCaseId = item.id;
      this.lastVersionId = item.last_version_id;
      console.log(item, '::item');
      console.log(this.useCaseId, this.lastVersionId, '::useCaseId, lastVersionId');
      this.$refs[modalName].onOpen();
    },
    openDeleteDialog: function openDeleteDialog(item) {
      this.itemToDelete = item;
      this.$refs[this.DIALOG_DELETE].onOpen();
    },
    handleDeleteConfirm: function handleDeleteConfirm(confirm) {
      var _this4 = this;
      if (confirm && this.itemToDelete) {
        UseCasesService.deleteResourcesDataset(this.itemToDelete.id).then(function () {
          tasks.toast.success('Eliminado correctamente');
          _this4.init();
        }).catch(function () {
          tasks.toast.error('Error al eliminar');
        });
      }
      this.$refs[this.DIALOG_DELETE].onClose();
    },
    submitExtendedValidity: function submitExtendedValidity(item) {
      var _this5 = this;
      if (!this.extendedValidityMonths) {
        tasks.toast.error('Por favor selecciona una fecha válida');
        return;
      }
      var payload = {
        add_time: this.extendedValidityMonths
      };
      console.log(item, '::item');
      UseCasesService.extendDateValidity(payload, item.id).then(function (response) {
        if (response.success) {
          tasks.toast.success(response.message || 'Se esta actualizando la vigencia. Espere un momento, por favor.');
          _this5.init();
          _this5.onCloseDialog(_this5.DIALOG_EXTEND_VALIDITY);
        } else {
          tasks.toast.error('Ocurrió un error al actualizar la vigencia');
        }
        _this5.extendedValidityMonths = null;
      }).catch(function (error) {
        console.error(error);
        tasks.toast.error('Error en el servidor');
      });
    }
  }, mapMutations('app', ['setShowLoading'])), {}, {
    checkCompanyCodeAndInit: function checkCompanyCodeAndInit() {
      if (this.companyCode) {
        this.init();
      } else {
        setTimeout(this.checkCompanyCodeAndInit, 2000);
      }
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
      var params = {
        user: this.userEmail
      };
      this.getUseCases(this.companyCode, {
        params: params
      });
    },
    onCloseAddSandboxBase: function onCloseAddSandboxBase() {
      console.log('onCloseAddSandboxBase called');
      this.$refs[this.DIALOG_ADD_SANDBOX_BASES].onClose();
      this.init(); // Aquí se asegura la recarga
    },
    onCloseDialogDesencriptarIdsandbox: function onCloseDialogDesencriptarIdsandbox(modalName) {
      console.log('onCloseAddSandboxBase called');
      this.$refs[this.DIALOG_DESENCRIPTAR_IDSANDBOX].onClose();
      this.init(); // Aquí se asegura la recarga
    },
    onCloseDialogSuccess: function onCloseDialogSuccess(modalName) {
      this.$refs[modalName].onClose();
      tasks.toast.success(this.translate('success_messages.general'), this.translate('titles.success'), 'ownership_history');
    },
    onSearch: function onSearch() {
      this.search = this.filters.text_filter;
      this.$router.push('/attributes/use_cases/history?q=' + this.search);
    },
    onCleanSearch: function onCleanSearch() {
      this.search = '';
      this.filters.text_filter = '';
      this.$router.push('/attributes/use_cases/history?q=' + '');
    },
    generateSandboxUrl: function generateSandboxUrl(item) {
      if (item.status_id === 3) {
        var projectId = item.project_sand;
        var datasetId = item.dataset_sand;
        var url = "https://console.cloud.google.com/bigquery?p=".concat(projectId, "&d=").concat(datasetId, "&project=").concat(projectId);
        window.open(url, '_blank');
      }
    },
    editAttributes: function editAttributes(item, modalName) {
      this.useCase = item;
      this.openDialog(modalName);
    },
    exportToAws: function exportToAws(item, modalName) {
      this.useCase = item;
      this.ListIbkAwsSchemes();
      this.openDialog(modalName);
    },
    onAddINCABases: function () {
      var _onAddINCABases = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(useCase, baseID) {
        var _this6 = this;
        var useCaseResponse, attributes, attributeToCheck, idToCheck, params;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log("use case: ", useCase);
              _context.n = 1;
              return UseCasesService.getUseCaseById(useCase.company_code, useCase.id);
            case 1:
              useCaseResponse = _context.v;
              attributes = useCaseResponse.data.attributes;
              attributeToCheck = useCase.attributes[0];
              idToCheck = "".concat(attributeToCheck.attribute_project_name, ".").concat(attributeToCheck.attribute_scheme_name, ".").concat(attributeToCheck.attribute_object_name); // const hasNoDuplicates = attributes.every(item => {
              //   const baseId = `${item.attribute_project_name}.${item.attribute_scheme_name}.${item.attribute_object_name}`
              //   return idToCheck !== baseId
              // })
              // if (!hasNoDuplicates) {
              // tasks.toast.error(this.translate('error_messages.duplicate_base'))
              //   return
              // }
              params = {
                company_code_usr: this.companyCode,
                company_name: useCase.company_name,
                append: true,
                flag_data_ext: '1',
                applicant: this.userEmail,
                // Solicitude id 2: Añadir base INCA
                solicitude_type_id: 2,
                rdetail: useCase.attributes,
                call_approval_method: false,
                access_deadline_date: this.useCase.access_deadline_date
              };
              console.log(useCase.company_code, useCase.id, false, params, '---------base INCA----');
              // this.init()
              UseCasesService.updateAttributesUseCase(useCase.company_code, useCase.id, false, params).then(function (response) {
                console.log(response);
                tasks.toast.success(_this6.translate('success_messages.general'), _this6.translate('titles.success'));
              }).catch(function (err) {
                console.error(err);
                tasks.toast.error(_this6.translate('error_messages.error_general'), _this6.translate('titles.error'));
              }).finally(function () {
                _this6.onCloseDialog(_this6.DIALOG_ADD_INCA_BASE);
                _this6.init();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onAddINCABases(_x, _x2) {
        return _onAddINCABases.apply(this, arguments);
      }
      return onAddINCABases;
    }(),
    init: function init() {
      console.log('[DEBUG] init llamado');
      var params = {
        user: this.userEmail,
        full: '1'
      };
      this.getUseCases(this.companyCode, {
        params: params
      });
      if (this.$route.query.q == null) {
        this.search = '';
      } else {
        this.search = this.$route.query.q;
      }
      this.filters.text_filter = this.search;
      this.items_key++;
    },
    refreshClick: function refreshClick() {
      this.init();
    },
    ListIbkAwsSchemes: function ListIbkAwsSchemes() {
      var _this7 = this;
      Promise.all([UseCasesService.getUseCaseById(this.useCase.company_code, this.useCase.id), UseCasesService.ListUseCaseViewColumns(this.useCase.id), UseCasesService.getIbkAwsSchemes()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          useCaseResponse = _ref2[0],
          viewColumnsResponse = _ref2[1],
          awsSchemesResponse = _ref2[2];
        if (useCaseResponse.success) {
          _this7.has_partyid_match = useCaseResponse.data.metadata[0].partyid_match != null;
          _this7.table_items = useCaseResponse.data.attributes;
        }
        if (viewColumnsResponse.success) {
          _this7.views_and_columns = viewColumnsResponse.data.records;
          console.log(_this7.views_and_columns, 'views_and_columns');
        }
        if (awsSchemesResponse.success) {
          _this7.aws_schemes = awsSchemesResponse.data.records;
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    onYesNO: function onYesNO(valor) {
      var _this8 = this;
      if (valor) {
        console.log(valor);
        console.log(this.useCase);
        var grouped = {};
        console.log(this.table_items);
        this.table_items.forEach(function (item) {
          if (!grouped[item.attribute_view_name]) {
            grouped[item.attribute_view_name] = [];
          }
          grouped[item.attribute_view_name].push(item);
        });
        var result = [];
        Object.keys(grouped).map(function (category) {
          var llave_periodo = 'process_date';
          // const columnas = [...new Set(grouped[category].map(item => item.attribute_name))]
          var columnas = _this8.views_and_columns[grouped[category][0].attribute_view_name];
          if (grouped[category][0].attribute_filters.process_date == null) {
            result.push({
              table_id: grouped[category][0].attribute_view_name,
              flag_periodo: 1 * 0,
              periodo: '',
              columnas: columnas,
              field_period: llave_periodo
            });
          } else {
            grouped[category][0].attribute_filters.process_date.map(function (item) {
              result.push({
                table_id: grouped[category][0].attribute_view_name,
                flag_periodo: 1 * 1,
                periodo: item,
                columnas: columnas,
                field_period: llave_periodo
              });
            });
          }
        });
        var body = {
          'id_use_case': this.useCase.id,
          'aws_schema': this.selected_aws_scheme,
          'tables': result
        };
        UseCasesService.postIbkExportSandboxToAws(body).then(function (response) {
          _this8.setShowLoading(false);
          if (response.code === 200) {
            tasks.toast.success(_this8.translate('success_messages.requested'), _this8.translate('titles.success'));
            _this8.onCloseDialog(_this8.DIALOG_EXPORT_AWS);
          } else {
            tasks.toast.error(_this8.translate('error_messages.error_general'), _this8.translate('titles.error'));
          }
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this8.translate('error_messages.error_general'), _this8.translate('titles.error'));
          _this8.setShowLoading(false);
        });
      } else {
        this.onCloseDialog(this.DIALOG_EXPORT_AWS);
      }
    }
  }),
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('descripcion.ownership_history'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        text: this.translate('table_ownership_history.use_case'),
        value: 'business_name',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.organization'),
        value: 'company_name',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.owner'),
        value: 'owner_name',
        align: 'start'
      }, {
        text: this.translate('table_ownership_history.date_created'),
        value: 'creation_date',
        align: 'center'
      }, {
        text: this.translate('table_ownership_history.attributes'),
        value: 'attribute_count',
        align: 'end'
      }, {
        text: this.translate('table_ownership_history.status'),
        value: 'status_id',
        align: 'center'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    totalRecords: function totalRecords() {
      if (this.items.length === 0) {
        return 0;
      } else {
        return this.pagination.total;
      }
    }
  })
};